<template>
	<div class="page">
		<v-card flat outlined class="wall-card">
			<v-card-title>
				Otwarte ankiety
			</v-card-title>

			<v-card-text>
				<div v-if="polls.length">
					<v-lazy
						v-for="(item, index) in polls"
						:key="`post-${item.id}- ${index}`"
						:options="{ threshold: 0 }"
						:transition="null"
						min-height="100"
					>
						<post :post="item" />
						<div
							v-if="index === polls.length - 2"
							v-intersect="infiniteScrolling"
						></div>
					</v-lazy>
				</div>
				<div v-if="isLoading">
					<div>
						<v-card
							v-for="i in skeletons"
							:key="i"
							flat
							outlined
							class="wall-card"
						>
							<v-card-text>
								<v-skeleton-loader
									:type="
										i % 2 == 0
											? 'image, article, actions'
											: 'article, action'
									"
								></v-skeleton-loader>
							</v-card-text>
						</v-card>
					</div>
					<div class="text-center text-muted">
						<v-progress-circular
							indeterminate
							size="34"
							color="$light-muted"
						></v-progress-circular>
						{{
							$vuetify.lang.t(
								"$vuetify.views.profile.loading"
							)
						}}
					</div>
				</div>
				<div v-else-if="!polls.length">Brak otwartych ankiet</div>
			</v-card-text>
		</v-card>
	</div>
</template>

<script>
import Post from "@/components/wall/post/Post";
// import axios from "axios";
import { mapGetters } from "vuex";

export default {
	components: {
		Post,
	},
	data() {
		return {
			// posts: [],
			isLoading: true,
			page: 1,
			total: "",
		};
	},
	methods: {
		async getPolls(page = null) {
			this.isLoading = true;

			let res = await this.$store.dispatch('wall/getPolls', {page: page});
			if(res.error) {
				this.$snackbar.error({error: res.error});
			}

			console.log("RESSSSS", res)
			this.isLoading = false;


			/*
			axios
				.get(`posts`, {
					params: { page: this.page, postable_type: "poll" },
				})
				.then((response) => {
					this.posts.push(...response.data.data);
					this.total = response.data.meta.last_page;
					this.page++;
				})
				.catch((error) => {
					console.log("GET USER POSTS POLLS ERROR", error);
				})
				.finally(() => {
					this.isLoading = false;
				});
				*/
		},

		async infiniteScrolling(entries, observer, isIntersecting) {
			if (isIntersecting && this.meta.current_page <= this.meta.last_page) {
				console.log("pobieranie");
				await this.getPolls(this.meta.current_page + 1);
			}
		},
	},

	computed: {
		...mapGetters({
			polls: 'wall/polls',
			meta: 'wall/pollsMeta'
		}),
		skeletons() {
			if (this.polls && this.polls.length) {
				return 2;
			}
			return 5;
		},

		extreme() {
			const extreme = (this.page - 1) * this.per_page - 2;
			return extreme;
		},
	},
	beforeDestroy() {
		this.$store.dispatch('wall/clearPolls');
	},
	created() {
		// this.getPolls = _.debounce(this.getPolls, 300);
		this.getPolls();
	},
};
</script>
